var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246.67,
    cy: 77.52,
    r: 48.12,
    transform: "translate(149.8 317.25) rotate(-85.44)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.17,
    cy: 77.04,
    r: 43.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.18,74.42s0,.24,0,.71,0,1.18,0,2.09c0,.46,0,1,0,1.53s.1,1.18.15,1.85.13,1.38.2,2.15a24,24,0,0,0,.41,2.42A41.83,41.83,0,0,0,208,97.09a43.57,43.57,0,0,0,10.26,13.08l1.79,1.52c.63.48,1.3.92,2,1.39s1.31,1,2,1.37l2.19,1.23c.37.21.74.42,1.12.62l1.17.52,2.39,1.06c.82.32,1.68.56,2.52.85a22.28,22.28,0,0,0,2.6.77,41.94,41.94,0,0,0,5.45,1c.94.09,1.88.25,2.83.29l2.89,0c.48,0,1,0,1.46,0l1.46-.13c1-.1,2-.15,3-.29A44.43,44.43,0,0,0,259,119.1l1.48-.43.74-.22.72-.29,2.9-1.17c.95-.44,1.86-1,2.81-1.44.46-.26.95-.47,1.4-.76l1.34-.88a49.1,49.1,0,0,0,5.21-3.87l2.37-2.29.59-.57.55-.63,1.08-1.27L281.3,104l1-1.37,1-1.38.48-.7c.15-.24.28-.49.42-.73l1.68-3c.46-1,.93-2.09,1.39-3.14a46.62,46.62,0,0,0,3.14-13.57A46.12,46.12,0,0,0,289,66.29q-.48-1.67-1-3.3c-.43-1.06-.85-2.11-1.28-3.16l-.32-.79-.39-.75-.78-1.5-.78-1.49-.91-1.4-.91-1.4-.46-.69-.51-.65-2-2.58A49.58,49.58,0,0,0,275,44.06l-1.22-1c-.4-.35-.86-.62-1.29-.94-.87-.59-1.71-1.23-2.6-1.79l-2.72-1.54-.67-.38c-.23-.12-.47-.22-.71-.32l-1.41-.63a46.72,46.72,0,0,0-5.68-2.08c-1-.26-1.94-.44-2.9-.66l-1.43-.32c-.48-.1-1-.13-1.45-.19l-2.87-.34c-1-.08-1.9,0-2.84-.08a40.7,40.7,0,0,0-5.55.28,21.81,21.81,0,0,0-2.67.42c-.87.18-1.76.3-2.61.52l-2.5.73-1.24.36-1.18.47-2.33.94a23.86,23.86,0,0,0-2.21,1.09c-.71.38-1.44.73-2.13,1.12l-2,1.28a43.39,43.39,0,0,0-11.88,11.63,41.71,41.71,0,0,0-5.6,11.28c-.25.83-.58,1.59-.73,2.35s-.32,1.45-.47,2.1-.3,1.25-.4,1.81-.13,1.07-.18,1.52q-.18,1.35-.27,2.07c-.06.46-.11.7-.11.7s0-.24.06-.71.12-1.17.22-2.07c0-.46.1-1,.16-1.53s.24-1.16.38-1.82l.45-2.12a24.59,24.59,0,0,1,.71-2.36,41.81,41.81,0,0,1,5.55-11.38,43.77,43.77,0,0,1,11.92-11.76l2-1.29c.7-.4,1.43-.76,2.15-1.14s1.43-.81,2.22-1.11l2.34-1,1.2-.47,1.24-.37,2.53-.75c.86-.22,1.75-.35,2.63-.53a24.1,24.1,0,0,1,2.7-.43,41.28,41.28,0,0,1,5.59-.29c.95,0,1.91,0,2.87.07l2.9.33c.48.07,1,.1,1.46.19l1.45.32c1,.22,1.95.4,2.93.67A46,46,0,0,1,264.56,37l1.43.63.71.32.68.39,2.75,1.55c.9.56,1.75,1.21,2.64,1.81.43.32.89.59,1.3.95l1.23,1.05A49.34,49.34,0,0,1,280,48.27l2.08,2.61.52.65.46.7.92,1.41.92,1.42.79,1.51.79,1.51.4.76.32.79,1.29,3.2c.33,1.11.66,2.22,1,3.33a46.89,46.89,0,0,1,1.36,14,47.25,47.25,0,0,1-3.18,13.72l-1.41,3.18-1.7,3c-.14.25-.27.5-.42.74l-.49.7-1,1.4-1,1.39-1.1,1.28-1.09,1.28-.55.64-.6.58-2.4,2.31a49.07,49.07,0,0,1-5.27,3.9l-1.36.88c-.44.3-.94.51-1.41.77-.95.49-1.88,1-2.85,1.45l-2.93,1.18-.72.29c-.25.09-.5.15-.75.23l-1.49.44a48.87,48.87,0,0,1-6,1.32c-1,.14-2,.18-3,.28l-1.48.13c-.5,0-1,0-1.48,0l-2.91,0c-1-.06-1.91-.21-2.86-.31a40.78,40.78,0,0,1-5.5-1,22.64,22.64,0,0,1-2.62-.78c-.85-.3-1.72-.54-2.54-.87l-2.41-1.07-1.18-.53-1.13-.63-2.2-1.25a24.46,24.46,0,0,1-2-1.38c-.67-.48-1.34-.93-2-1.41l-1.8-1.54a43.78,43.78,0,0,1-10.28-13.22,41.68,41.68,0,0,1-4-12,24,24,0,0,1-.4-2.43c-.06-.77-.12-1.49-.17-2.16s-.12-1.29-.13-1.86,0-1.07,0-1.53c0-.91,0-1.6.06-2.09S203.18,74.42,203.18,74.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,78.23a9.61,9.61,0,0,1-1.55.1l-4.25.09c-3.62,0-8.65.08-14.33.09h-.28V75.39c0-6.35,0-12.09.08-16.25,0-2,.07-3.66.09-4.92a10.54,10.54,0,0,1,.11-1.81,10.54,10.54,0,0,1,.11,1.81c0,1.26.05,2.92.09,4.92.05,4.16.08,9.9.08,16.25v2.84l-.28-.28c5.68,0,10.71,0,14.33.09l4.25.09A8.33,8.33,0,0,1,267,78.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,40.27a12,12,0,0,1,.29,3.68,11.89,11.89,0,0,1-.29,3.68,12.48,12.48,0,0,1-.28-3.68A12.53,12.53,0,0,1,247,40.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,46.18A12,12,0,0,1,264.6,49a12,12,0,0,1-2.77,2.36,11.79,11.79,0,0,1,2.37-2.76A11.79,11.79,0,0,1,267,46.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.63,58.93a15.62,15.62,0,0,1-3,2,15.05,15.05,0,0,1-3.18,1.75,9.66,9.66,0,0,1,2.89-2.24A9.6,9.6,0,0,1,278.63,58.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,77.85a45.05,45.05,0,0,1-10,0,43.51,43.51,0,0,1,10,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,77.18a20,20,0,0,1-4.74.28,20,20,0,0,1-4.74-.28,20,20,0,0,1,4.74-.28A20,20,0,0,1,215.9,77.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.82,91.26a20.45,20.45,0,0,1-3.58,3.25,21,21,0,0,1-3.94,2.81,20.91,20.91,0,0,1,3.58-3.25A20.46,20.46,0,0,1,220.82,91.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,102.15a31.78,31.78,0,0,1-2.44,4.23,31.63,31.63,0,0,1-2.59,4.13,16.17,16.17,0,0,1,2.1-4.42A15.8,15.8,0,0,1,233,102.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,116.2a23,23,0,0,1-.28-5,23,23,0,0,1,.28-5,21.93,21.93,0,0,1,.29,5A21.88,21.88,0,0,1,247,116.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.63,109.52a14.82,14.82,0,0,1-4.14-2.84,14.62,14.62,0,0,1-3.37-3.71,44.24,44.24,0,0,1,3.75,3.29A44.63,44.63,0,0,1,268.63,109.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.78,98.59a17.37,17.37,0,0,1-3.32-2.93,17.09,17.09,0,0,1-2.92-3.32,17.87,17.87,0,0,1,3.32,2.92A17.74,17.74,0,0,1,278.78,98.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,63.69a13.69,13.69,0,0,1-2.94-2.53,13.42,13.42,0,0,1-2.53-2.94,13.4,13.4,0,0,1,2.93,2.54A13.4,13.4,0,0,1,220.36,63.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,50.49A12.75,12.75,0,0,1,230,48a12.81,12.81,0,0,1-2.48-2.87,13.08,13.08,0,0,1,2.88,2.47A13.06,13.06,0,0,1,232.88,50.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.18,77.46A43.54,43.54,0,0,1,249.13,34c-.85,0-1.72-.08-2.59-.08a43.55,43.55,0,0,0,0,87.09c.87,0,1.74,0,2.59-.09A43.54,43.54,0,0,1,208.18,77.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.1,
    y: 105.8,
    width: 132.83,
    height: 209.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.68,
    y: 109.74,
    width: 125.22,
    height: 202.53,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.29,
    y: 121.54,
    width: 49.93,
    height: 77.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,128.39a1.87,1.87,0,1,1-1.86-1.86A1.86,1.86,0,0,1,430.91,128.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.97,
    y: 220.59,
    width: 49.93,
    height: 77.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,227.44a1.87,1.87,0,1,1-1.86-1.87A1.86,1.86,0,0,1,380.59,227.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.29,
    y: 121.54,
    width: 42.64,
    height: 60.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,127a1.55,1.55,0,1,1-1.55-1.55A1.54,1.54,0,0,1,375.16,127Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.54,
    y: 224.14,
    width: 45.9,
    height: 25.43,
    transform: "translate(-23.82 50.09) rotate(-6.44)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.6,
    cy: 229.02,
    r: 1.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,238.26c0,.2-7.84.37-17.51.37s-17.51-.17-17.51-.37,7.83-.37,17.51-.37S396.24,238.05,396.24,238.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,243.8c0,.21-7.84.37-17.51.37s-17.51-.16-17.51-.37,7.83-.37,17.51-.37S396.24,243.6,396.24,243.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,249.35c0,.2-7.84.37-17.51.37s-17.51-.17-17.51-.37,7.83-.38,17.51-.38S396.24,249.14,396.24,249.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,254.89c0,.2-7.84.37-17.51.37s-17.51-.17-17.51-.37,7.83-.37,17.51-.37S396.24,254.68,396.24,254.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,260.43c0,.21-7.84.38-17.51.38s-17.51-.17-17.51-.38,7.83-.37,17.51-.37S396.24,260.23,396.24,260.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,266c0,.2-7.84.37-17.51.37s-17.51-.17-17.51-.37,7.83-.38,17.51-.38S396.24,265.77,396.24,266Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,271.52c0,.21-7.84.37-17.51.37s-17.51-.16-17.51-.37,7.83-.37,17.51-.37S396.24,271.31,396.24,271.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,232.32c0,.2-7.71,1.46-17.29,2.82s-17.36,2.28-17.39,2.07,7.71-1.46,17.29-2.81S450.56,232.12,450.59,232.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.29,235.79c0,.2-7.72,1.46-17.29,2.81s-17.37,2.28-17.39,2.08,7.71-1.46,17.28-2.81S451.26,235.58,451.29,235.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92,239c0,.2-7.71,1.46-17.29,2.81s-17.36,2.29-17.39,2.08,7.71-1.46,17.29-2.81S451.89,238.79,451.92,239Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,137.75c0,.21-8.86.37-19.78.37s-19.79-.16-19.79-.37,8.86-.37,19.79-.37S448.83,137.54,448.83,137.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,141.05c0,.2-8.86.37-19.78.37s-19.79-.17-19.79-.37,8.86-.38,19.79-.38S448.83,140.84,448.83,141.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,144.34c0,.21-8.86.37-19.78.37s-19.79-.16-19.79-.37,8.86-.37,19.79-.37S448.83,144.14,448.83,144.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,147.64c0,.2-8.86.37-19.78.37s-19.79-.17-19.79-.37,8.86-.37,19.79-.37S448.83,147.43,448.83,147.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,150.93c0,.21-8.86.38-19.78.38s-19.79-.17-19.79-.38,8.86-.37,19.79-.37S448.83,150.73,448.83,150.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,154.23c0,.21-8.86.37-19.78.37s-19.79-.16-19.79-.37,8.86-.37,19.79-.37S448.83,154,448.83,154.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,157.53c0,.2-8.86.37-19.78.37s-19.79-.17-19.79-.37,8.86-.38,19.79-.38S448.83,157.32,448.83,157.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.83,167.31c0,.2-8.86.37-19.78.37s-19.79-.17-19.79-.37,8.86-.37,19.79-.37S448.83,167.1,448.83,167.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.11,170.79c0,.2-8.86.37-19.78.37s-19.79-.17-19.79-.37,8.86-.37,19.79-.37S449.11,170.58,449.11,170.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.39,174.27c0,.21-8.86.37-19.78.37s-19.79-.16-19.79-.37,8.86-.37,19.79-.37S449.39,174.07,449.39,174.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.67,177.75c0,.21-8.86.37-19.79.37s-19.78-.16-19.78-.37,8.86-.37,19.78-.37S449.67,177.55,449.67,177.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,181.23c0,.21-8.86.38-19.79.38s-19.78-.17-19.78-.38,8.85-.37,19.78-.37S450,181,450,181.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.22,184.72c0,.2-8.85.37-19.78.37s-19.78-.17-19.78-.37,8.85-.38,19.78-.38S450.22,184.51,450.22,184.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.19,
    y: 73.75,
    width: 125.06,
    height: 181.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.93,
    y: 73.75,
    width: 125.06,
    height: 181.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.47,
    y: 93.38,
    width: 93.99,
    height: 142.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,235.39s0-.24,0-.69,0-1.14,0-2c0-1.78,0-4.39,0-7.79,0-6.8,0-16.72-.09-29.25,0-25-.09-60.5-.15-102.26l.31.32-94,0h0l.34-.34c0,53.58-.05,103-.07,142l-.27-.27,68.4.14,18.9.07,5,0,1.71,0s-.55,0-1.66,0l-4.91,0-18.84.07-68.57.14h-.28v-.27c0-39,0-88.43-.06-142V93h.36l94,0h.31v.31c-.06,41.85-.11,77.38-.15,102.47,0,12.49-.06,22.39-.08,29.18,0,3.36,0,5.95,0,7.72,0,.86,0,1.52,0,2S141.45,235.39,141.45,235.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,73.75A21.9,21.9,0,0,1,155.11,77c-1.45,1.94-3.51,4.59-5.87,7.44s-4.55,5.39-6.18,7.19a21.85,21.85,0,0,1-2.75,2.81,22.9,22.9,0,0,1,2.39-3.12c1.67-2,3.74-4.54,6-7.31l6-7.31A23.21,23.21,0,0,1,157.34,73.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,234.93a116.15,116.15,0,0,0,16.39,20.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,255.43a18.36,18.36,0,0,1-2.86-2.6,91.15,91.15,0,0,1-11.62-14.54,18.41,18.41,0,0,1-1.91-3.36,27.16,27.16,0,0,1,2.31,3.09c1.37,1.94,3.31,4.59,5.57,7.42s4.42,5.29,6,7.07A26.28,26.28,0,0,1,158.32,255.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.91,254.88l16.38-20.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.29,234.67c.15.12-3.4,4.74-7.93,10.32s-8.3,10-8.45,9.89,3.4-4.74,7.93-10.32S48.14,234.55,48.29,234.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.93,73.75c.14-.11,3.7,4.14,8,9.51s7.56,9.81,7.42,9.92-3.71-4.13-8-9.5S31.78,73.87,31.93,73.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.7,
    y: 122.22,
    width: 31.47,
    height: 89.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,429.11s-5.71-39.25-5.24-62.08,0-48.53,0-48.53h2.64s-1.79,45.33.15,72.67,7,37.94,7,37.94h-4.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.57,274.34a6.93,6.93,0,0,0-2.4-3.51c-1.66-1.06-3.85-.62-5.71,0-8,2.81-15,17.63-18.21,25.43l10.55,35.55C246.85,314.18,250.15,291,243.57,274.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,272.27a2.78,2.78,0,0,1-.15.46l-.52,1.3c-.46,1.12-1.11,2.74-1.89,4.76-1.55,4-3.53,9.69-5.3,16s-3,12.22-3.73,16.48c-.37,2.13-.66,3.86-.84,5.06-.09.55-.16,1-.22,1.37a1.9,1.9,0,0,1-.11.48,2.27,2.27,0,0,1,0-.49c0-.36.09-.82.15-1.39.12-1.2.36-2.94.7-5.08a151.06,151.06,0,0,1,3.61-16.55,149.21,149.21,0,0,1,5.44-16c.81-2,1.5-3.62,2-4.72l.6-1.26A2.22,2.22,0,0,1,240.56,272.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,340.38c-9.89-5.47-15.72-15.75-16.26-27-.39-7.89,2-15.63,4.79-23a3,3,0,0,1,1.11-1.67,2.85,2.85,0,0,1,2.7.42c7.19,4.09,11.54,11.9,13.86,19.84a40.11,40.11,0,0,1,1.63,16.31,27.17,27.17,0,0,1-7.83,15.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,340.38a1.61,1.61,0,0,1,0-.48c0-.36,0-.81,0-1.36,0-1.19-.06-2.9-.15-5a137.55,137.55,0,0,0-1.84-16.43c-1.1-6.37-2.43-12.07-3.41-16.19-.48-2-.88-3.67-1.17-4.89l-.3-1.33a1.48,1.48,0,0,1-.08-.47,2.32,2.32,0,0,1,.16.45l.38,1.31c.33,1.14.78,2.8,1.31,4.85,1.06,4.11,2.44,9.81,3.54,16.2a120.28,120.28,0,0,1,1.71,16.48c.06,2.13.06,3.84,0,5,0,.55,0,1-.05,1.36A2.53,2.53,0,0,1,223.11,340.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,400.43c9.74,2.14,17.75,9,27.14,12.35,6.22,2.21,13.24,3,18.2,7.33-1.19-3-4-5-6.75-6.72a121,121,0,0,0-24.6-11.74c-4.42-1.53-9.21-2.8-13.72-1.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.19,409.11c-12.19-.2-25-10.58-37.16-11.2,12.7-4.1,30.88-.75,37.16,11.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,379.86c6.19-2.23,13-2.34,19.49-1.33s12.78,3.1,19,5.18c-.63-4.23-4.05-7.41-7.27-10.23a50.36,50.36,0,0,0-7.64-5.87A17,17,0,0,0,239.4,365a14.53,14.53,0,0,0-10.11,5.1,16.79,16.79,0,0,0-4.33,9.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.94,366.4c-7.68-6.55-19.3-5.91-29.39-5.68a238.85,238.85,0,0,1,45.57,28.4C216.53,382,209.63,374.68,199.94,366.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,357.35a86.19,86.19,0,0,1,11.8-6.86c4-1.83,7.81-4.75,11.71-6.87,5.06-2.74,9.44-6.54,14.09-9.94s9.74-6.46,15.42-7.36a30.25,30.25,0,0,0-14,.81,91.42,91.42,0,0,0-13.21,5.14c-6,2.7-12.08,5.46-17,9.84s-9.32,8.7-8.8,15.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19,409.11a2,2,0,0,1-.39-.17l-1.06-.55c-.92-.49-2.24-1.21-3.9-2.05-.82-.43-1.73-.88-2.72-1.35s-2-1-3.16-1.45a47.45,47.45,0,0,0-7.51-2.62,16.14,16.14,0,0,0-7.82-.19,22.24,22.24,0,0,0-3.31,1,16.35,16.35,0,0,0-2.68,1.37,17.13,17.13,0,0,0-3.36,2.78c-.71.75-1.05,1.22-1.08,1.19a1.36,1.36,0,0,1,.22-.35,11.74,11.74,0,0,1,.73-1,16,16,0,0,1,3.32-2.92,16.77,16.77,0,0,1,2.71-1.45,22.07,22.07,0,0,1,3.36-1,16.29,16.29,0,0,1,8,.16,45,45,0,0,1,7.57,2.67c1.13.5,2.19,1,3.16,1.5s1.89.95,2.71,1.4c1.64.87,2.94,1.64,3.83,2.17l1,.62C261.08,409,261.2,409.09,261.19,409.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.1,403.07a2.63,2.63,0,0,1,.76.22,17.21,17.21,0,0,1,2,.86A24.06,24.06,0,0,1,224,413.94a16.1,16.1,0,0,1,.94,1.95,2.55,2.55,0,0,1,.25.75c-.07,0-.52-1-1.46-2.55a27.24,27.24,0,0,0-10.06-9.67C212.12,403.55,211.07,403.14,211.1,403.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.13,365.79a2.39,2.39,0,0,1,.52.15l1.46.52,2.31.85c.9.34,1.87.83,3,1.32a70.14,70.14,0,0,1,15.87,10.11,76.5,76.5,0,0,1,7.4,7.29,81.47,81.47,0,0,1,5.25,6.65c1.4,2,2.45,3.62,3.17,4.75.35.54.62,1,.84,1.31a2.59,2.59,0,0,1,.27.47,2.21,2.21,0,0,1-.34-.42c-.22-.28-.53-.71-.91-1.26-.76-1.11-1.86-2.72-3.28-4.67s-3.2-4.18-5.3-6.57a83.39,83.39,0,0,0-7.38-7.22,74.18,74.18,0,0,0-15.72-10.16c-1.1-.51-2.06-1-3-1.37l-2.27-.92-1.43-.6A2.73,2.73,0,0,1,184.13,365.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,373a4.29,4.29,0,0,1-1-.13l-1.12-.2c-.44-.09-.94-.09-1.5-.15A15.19,15.19,0,0,0,227.47,377a17.27,17.27,0,0,0-2.45,3,27.73,27.73,0,0,0-1.68,3.19,4.11,4.11,0,0,1,.25-.95,14.08,14.08,0,0,1,1.17-2.41,16.12,16.12,0,0,1,2.43-3.15,14.81,14.81,0,0,1,12.5-4.5,13.77,13.77,0,0,1,1.51.21l1.12.28A4,4,0,0,1,243.25,373Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,335a2.46,2.46,0,0,1-.46.28l-1.36.74c-1.18.64-2.88,1.58-5,2.79s-4.48,2.76-7.06,4.6a59.35,59.35,0,0,0-7.89,6.61,19.6,19.6,0,0,0-3.22,4.17c-.8,1.54-1.57,3-2.27,4.44a77.53,77.53,0,0,0-3.38,7.71,45.62,45.62,0,0,0-1.65,5.43c-.31,1.31-.43,2-.47,2a2.68,2.68,0,0,1,.05-.54c0-.36.12-.87.25-1.53a40.15,40.15,0,0,1,1.53-5.5,74,74,0,0,1,3.31-7.79c.7-1.43,1.45-2.92,2.25-4.45a20.26,20.26,0,0,1,3.29-4.29,57.11,57.11,0,0,1,8-6.63c2.6-1.83,5.05-3.33,7.14-4.53s3.82-2.09,5-2.68l1.39-.67A2,2,0,0,1,255.5,335Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,371.91a4.49,4.49,0,0,1-.24-1c-.15-.75-.32-1.69-.54-2.81a78,78,0,0,0-2.3-9.15,80.31,80.31,0,0,0-3.48-8.77c-.48-1-.88-1.92-1.19-2.61a4.56,4.56,0,0,1-.39-1,5.24,5.24,0,0,1,.54.9c.32.6.78,1.47,1.31,2.55a60.31,60.31,0,0,1,5.82,18c.19,1.2.32,2.17.39,2.85A4.85,4.85,0,0,1,221.32,371.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.44,344.17a33.14,33.14,0,0,0-4-13.16,43.45,43.45,0,0,0-29.45-22l27.27,40.64,3.52,7.25C220.21,353,220.74,348.78,220.44,344.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.15,
    y: 424.26,
    width: 63.4,
    height: 11.24,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.88 433.27 206.28 468.13 248.37 468.13 254.81 433.27 200.88 433.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51,435.51c0,.12-14.3.22-31.94.22s-31.94-.1-31.94-.22,14.3-.22,31.94-.22S259.51,435.39,259.51,435.51Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.76,468.36c0-.14,100.81-.26,225.14-.26s225.16.12,225.16.26-100.79.26-225.16.26S16.76,468.51,16.76,468.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.41,189.14c-.15,0-.19-5.5-.1-12.28s.28-12.27.42-12.27.19,5.5.1,12.28S244.55,189.14,244.41,189.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.74,196.11a69.83,69.83,0,0,1-5.1-6.82,69.88,69.88,0,0,1-4.66-7.12,69.28,69.28,0,0,1,5.09,6.82A67.82,67.82,0,0,1,209.74,196.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,194.42a16.6,16.6,0,0,1-2.1,2c-1.34,1.18-3.24,2.77-5.38,4.46s-4.12,3.18-5.57,4.22a14.89,14.89,0,0,1-2.43,1.58,18.2,18.2,0,0,1,2.21-1.87l5.47-4.33,5.46-4.34A16.15,16.15,0,0,1,281.07,194.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.93,172.25l.41.83a.28.28,0,0,0,.22.16l.92.14a.29.29,0,0,1,.17.5l-.67.65a.29.29,0,0,0-.08.26l.15.92a.29.29,0,0,1-.43.31l-.82-.43a.34.34,0,0,0-.28,0l-.82.43a.29.29,0,0,1-.43-.31l.16-.92a.32.32,0,0,0-.09-.26l-.66-.65a.29.29,0,0,1,.16-.5l.92-.14a.27.27,0,0,0,.22-.16l.41-.83A.3.3,0,0,1,224.93,172.25Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75,209.68l.41.83a.33.33,0,0,0,.23.17l.92.13a.3.3,0,0,1,.16.51l-.66.65a.3.3,0,0,0-.09.26l.16.91a.3.3,0,0,1-.43.32l-.82-.44a.34.34,0,0,0-.28,0l-.82.44a.3.3,0,0,1-.43-.32l.15-.91a.27.27,0,0,0-.08-.26l-.67-.65a.3.3,0,0,1,.17-.51l.92-.13a.32.32,0,0,0,.22-.17l.41-.83A.3.3,0,0,1,287.75,209.68Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,175.55l.75,1.52a.56.56,0,0,0,.41.3l1.67.24a.54.54,0,0,1,.3.92l-1.21,1.18a.54.54,0,0,0-.15.48l.28,1.67a.54.54,0,0,1-.78.57l-1.5-.79a.55.55,0,0,0-.5,0l-1.5.79a.54.54,0,0,1-.79-.57l.29-1.67a.55.55,0,0,0-.16-.48l-1.21-1.18a.54.54,0,0,1,.3-.92l1.68-.24a.54.54,0,0,0,.4-.3l.75-1.52A.54.54,0,0,1,267.33,175.55Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.74,214.86l.75,1.51a.56.56,0,0,0,.4.3l1.68.24a.54.54,0,0,1,.3.92L191.66,219a.52.52,0,0,0-.16.47l.29,1.67a.54.54,0,0,1-.79.57l-1.49-.79a.57.57,0,0,0-.51,0l-1.5.79a.54.54,0,0,1-.78-.57l.29-1.67a.52.52,0,0,0-.16-.47l-1.21-1.19a.54.54,0,0,1,.3-.92l1.67-.24a.56.56,0,0,0,.41-.3l.75-1.51A.54.54,0,0,1,189.74,214.86Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,240.85l.75,1.51a.56.56,0,0,0,.41.3l1.67.24a.54.54,0,0,1,.3.92L278.67,245a.52.52,0,0,0-.16.47l.29,1.67a.54.54,0,0,1-.79.57l-1.49-.79a.57.57,0,0,0-.51,0l-1.49.79a.54.54,0,0,1-.79-.57l.29-1.67a.52.52,0,0,0-.16-.47l-1.21-1.19a.54.54,0,0,1,.3-.92l1.67-.24a.56.56,0,0,0,.41-.3l.75-1.51A.54.54,0,0,1,276.75,240.85Z",
    style: {
      fill: "#9DE6B2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.23 122.67 340.73 109.91 342.32 130.63 364.38 129.16 349.77 148.25 363.34 161.62 340.31 165.38 345.53 190.76 328.66 172.14 308.21 184.07 308.44 163.28 286.44 157.01 303.3 144.47 290.87 127.49 308.95 130.38 309.4 110.05 324.23 122.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,156.88l-.27.2.32.09,22,6.28-.12-.17c-.08,6.61-.16,13.62-.24,20.79v.32l.28-.16,20.45-11.93-.23,0,4.6,5.08,12.27,13.55.45.5-.13-.66q-2.68-13-5.23-25.39l-.14.21,23-3.76.33,0-.24-.24-13.58-13.36v.21l14.6-19.1.19-.25-.31,0-22.06,1.49.12.11c-.63-8.16-1.17-15-1.61-20.72v-.16l-.13.1-12.23,9.51-3.15,2.46-1.07.85,1.07-.8,3.16-2.42L340.79,110l-.14-.06c.42,5.7.94,12.56,1.55,20.73v.12h.11l22.07-1.45-.13-.23c-4.54,5.93-9.43,12.32-14.62,19.08l-.09.12.1.09q6.53,6.45,13.57,13.38l.09-.28-23,3.74-.18,0,0,.18q2.52,12.35,5.21,25.39l.31-.16L333.4,177.09c-1.58-1.73-3.15-3.47-4.6-5.08l-.1-.11-.13.08-20.45,11.94.27.16c.08-7.17.15-14.19.23-20.79v-.14l-.13,0-22-6.26.06.3,16.85-12.56.12-.09-.09-.13-12.44-17-.13.22,18.08,2.86.13,0v-.13c.17-7.89.31-14.75.43-20.33l-.14.06,11,9.34,2.87,2.41c.64.54,1,.8,1,.8l-1-.85-2.85-2.45-11-9.38-.13-.11v.18c-.13,5.57-.3,12.44-.49,20.32l.14-.11-18.08-2.9-.33,0,.2.26,12.41,17,0-.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,136.8,323.84,151a2.31,2.31,0,0,0,2.26,2.07h0a2.31,2.31,0,0,0,2.35-2.16l1-14.41a1.83,1.83,0,0,0-1.92-1.94l-3.48.21A1.81,1.81,0,0,0,322.31,136.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54,159.7a3.48,3.48,0,1,1-2.4-4.31A3.48,3.48,0,0,1,329.54,159.7Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.38,327.25c-4.57-5.23-12.31-6.33-17.78-10.61-7.37-5.77-9.24-16.09-9.5-25.46s.46-19.19-3.61-27.63a26.94,26.94,0,0,0-26.34-14.69l-12.33,12c5.61,6.24,8.85,15.91,7.52,24.2s-8.5,24.08-9.18,32.45c-1.47,18.22,5.69,31.47,22.34,39,4.11,1.86,8.66,3.11,13.12,2.48s8.82-3.47,10.29-7.74c7.33,3.67,16.89,3.3,23.11-2S483.78,333.42,478.38,327.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.63,240.33s5.33-10.3,6.66-11.39,3.27-.85,3.15,1-2.42,7-2.42,7,4-11.74,7.14-14.05,3.52-.48,3.52,1.22c0,0,2.3-7.6,5.33-6.23s.6,6.1.6,6.1,3.27-5.93,5.69-3.81-4.11,13.38-4.11,13.38,2.42-1.09,1.69,3.27-1.57,10.54-3.63,14.17-6.78,12.36-10.42,17.57S248,319.9,248,319.9s-15.75,9.33-23.38,8.12l-3-.49,9.81-55.83s-2.12-3.88-1.66-10.66S239.63,240.33,239.63,240.33Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,238.36a18.19,18.19,0,0,1-2.72.24c-1.69.12-4,.33-6.54.73s-4.81.91-6.45,1.3a16.71,16.71,0,0,1-2.68.58,11.62,11.62,0,0,1,2.59-.93,50.58,50.58,0,0,1,6.46-1.47,49.44,49.44,0,0,1,6.6-.58A11.61,11.61,0,0,1,260,238.36Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,223.47a11,11,0,0,1-.84,2.47c-.6,1.49-1.51,3.52-2.63,5.71s-2.22,4.11-3.08,5.47a11.6,11.6,0,0,1-1.49,2.13,13.69,13.69,0,0,1,1.18-2.31c.77-1.41,1.82-3.35,2.93-5.53s2.06-4.17,2.75-5.62A15.7,15.7,0,0,1,258,223.47Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,222.83a14.64,14.64,0,0,1-1.26,2.28l-3.21,5.39-3.16,5.43a14.38,14.38,0,0,1-1.38,2.21,12.43,12.43,0,0,1,1.06-2.39c.73-1.44,1.78-3.39,3-5.51s2.44-4,3.35-5.33A11.56,11.56,0,0,1,264.18,222.83Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,260.56s0-.13.05-.37.15-.59.29-1a15.61,15.61,0,0,1,1.72-3.55,16.46,16.46,0,0,1,4-4.24c1.77-1.32,3.94-2.42,5.68-4.18,3.59-3.57,3.91-8.59,6.17-11.2a7.1,7.1,0,0,1,3.13-2.39,3.81,3.81,0,0,1,1.06-.21,1.15,1.15,0,0,1,.37,0,9,9,0,0,0-1.36.37,7.31,7.31,0,0,0-2.91,2.43A19.4,19.4,0,0,0,259,241.4a17,17,0,0,1-3.66,6.16c-1.83,1.84-4,2.92-5.76,4.2a16.47,16.47,0,0,0-4,4.06A22.6,22.6,0,0,0,243.22,260.56Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.41,227.11c-5.57-14.07-15.79-24.4-30.13-29.23-8.09-2.72-12-2.1-18.35-2.39s-12.65,1.17-17.73,5c-6,4.57-11.61,10.05-14.68,17-3.15,7.1-6.31,14.25-8.11,21.81s-2.16,15.63.28,23l17.74,9.24c10.26,3.66,20.67,7.35,31.53,8.2s22.41-1.45,30.64-8.59C429,261.24,432,241.18,426.41,227.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.74,221.67l-21.87-17.93-6.78-1.33c-14.73-4.63-30.06,8.37-33.95,20.26-4.32,13.2-9.09,29.5-10.09,39.93-2,21,14.21,27.95,14.21,27.95s-1.14,3.1-3.37,9.65l-2.45,1.86c1.34,11.5,18.24,16.64,36.28,9.71l.76-.63,31.74-80.64A7.32,7.32,0,0,0,409.74,221.67Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7,240a2.67,2.67,0,0,0,1.82,3.25,2.55,2.55,0,0,0,3.27-1.64,2.67,2.67,0,0,0-1.81-3.25A2.56,2.56,0,0,0,347.7,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,230.72c.23.42,2.56-.53,5.34.2s4.46,2.65,4.85,2.39c.19-.12,0-.81-.7-1.69a7.34,7.34,0,0,0-3.77-2.32,7.1,7.1,0,0,0-4.37.25C349.85,230,349.4,230.52,349.52,230.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.25,257.74c.06-.15-1.6-.9-4.3-2-.69-.26-1.33-.58-1.32-1.09a3.64,3.64,0,0,1,1-2c1.11-1.55,2.27-3.17,3.5-4.87,4.91-6.94,8.66-12.72,8.38-12.91s-4.49,5.27-9.4,12.21c-1.2,1.72-2.34,3.35-3.42,4.92a4.19,4.19,0,0,0-1.09,2.69,1.83,1.83,0,0,0,.89,1.34,4.75,4.75,0,0,0,1.17.48C358.46,257.43,360.2,257.9,360.25,257.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.23,290.52a53,53,0,0,0,28.85-.21s-10.81,12.1-30.48,5Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5,221.44c.29.8,2.54.9,5,1.75s4.32,2,5,1.57c.32-.23.22-1-.46-1.87a7.78,7.78,0,0,0-3.67-2.47,7.65,7.65,0,0,0-4.39-.21C353.89,220.53,353.38,221.06,353.5,221.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.29,248.23a2.65,2.65,0,0,1-3.23,1.84,2.54,2.54,0,0,1-1.95-3.09,2.67,2.67,0,0,1,3.24-1.84A2.54,2.54,0,0,1,377.29,248.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.84,241.44c-.42.24-1.93-1.78-4.68-2.59s-5.18,0-5.38-.47c-.1-.2.4-.7,1.47-1.08a7.31,7.31,0,0,1,4.43,0,7.13,7.13,0,0,1,3.6,2.48C386.93,240.65,387,241.34,386.84,241.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,232.16c-.73.46-2.66-.82-5.2-1.62s-4.84-1-5.14-1.79c-.12-.38.4-.91,1.53-1.22a8.7,8.7,0,0,1,8.33,2.75C388.21,231.19,388.31,231.93,388,232.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.22,262.69c.39-1.5,3-4.59,4.58-4.44,4.12.41,11.17,2.58,8.63,12.64-3.47,13.76-19.69,7-19.62,6.6S398.86,267.86,400.22,262.69Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,273.86c.07,0,.2.23.56.52a2.5,2.5,0,0,0,1.78.49c1.59-.17,3.39-2.17,4.09-4.63a8.1,8.1,0,0,0,.19-3.6,2.87,2.87,0,0,0-1.34-2.3,1.27,1.27,0,0,0-1.58.3c-.28.34-.26.64-.34.64s-.24-.3,0-.84a1.52,1.52,0,0,1,.75-.73,1.92,1.92,0,0,1,1.42,0,3.48,3.48,0,0,1,2,2.77,8.31,8.31,0,0,1-.13,4c-.79,2.75-2.86,5-5,5.06a2.65,2.65,0,0,1-2.1-.91C401.94,274.2,402,273.87,402,273.86Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.34,258.47l-4.56,2.46c-10.29-18.89-27.93-63.59-27-61,0,0,11.47-.94,21.88,4.44s29.54,17.54,25.08,30.43S405.34,258.47,405.34,258.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.25,259.94a3.69,3.69,0,0,0,0-.82,15.25,15.25,0,0,0-.25-2.35,20.1,20.1,0,0,0-3.59-7.9A38.08,38.08,0,0,0,412,240c-4-2.83-8.63-5.53-12.87-9.17a68.47,68.47,0,0,1-10.8-11.39,71.54,71.54,0,0,1-6.71-10.91,75.25,75.25,0,0,1-3.35-7.95l-.76-2.22a3.47,3.47,0,0,0-.31-.77,4.19,4.19,0,0,0,.17.81c.14.52.33,1.29.63,2.27a64.16,64.16,0,0,0,3.17,8.07,68.36,68.36,0,0,0,6.63,11.08,67.37,67.37,0,0,0,10.87,11.55c4.3,3.68,9,6.37,13,9.16a39.06,39.06,0,0,1,9.44,8.6,20.77,20.77,0,0,1,3.72,7.67C425.21,258.8,425.17,259.94,425.25,259.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.3,262.61a7.58,7.58,0,0,0,.41-3.12,14.49,14.49,0,0,0-3-8c-2.14-3-5.75-5.58-9.85-8a69.36,69.36,0,0,1-12.58-8.9,62.33,62.33,0,0,1-10-11.67,63.65,63.65,0,0,1-5.88-11.14,68.94,68.94,0,0,1-2.68-8.07l-.54-2.25a2.81,2.81,0,0,0-.24-.78,3.69,3.69,0,0,0,.1.8c.1.61.24,1.36.41,2.3a57.53,57.53,0,0,0,2.47,8.19,61.21,61.21,0,0,0,15.89,23.16,67.93,67.93,0,0,0,12.73,8.93c4.1,2.38,7.65,4.87,9.78,7.74a14.61,14.61,0,0,1,3.18,7.68A17.48,17.48,0,0,1,421.3,262.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24,261.82a2.18,2.18,0,0,1,1.31-.06,1.84,1.84,0,0,1,.86.84,4.86,4.86,0,0,1-5.56,7.11c-1.85-.54-3.75-2.23-3.89-5.91C363.23,263.23,366,262.38,368.24,261.82Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,269.84a7,7,0,0,0,3-.39,4.53,4.53,0,0,0,2.33-2.13,4.77,4.77,0,0,0,.19-3.81c-.26-.63-.63-1.28-1.13-1.34a6.3,6.3,0,0,0-1.85.33l-3.33.83a14.49,14.49,0,0,1-3.12.6,14,14,0,0,1,3-1.08l3.3-1a5.81,5.81,0,0,1,2.12-.39,1.73,1.73,0,0,1,1.09.71,4.34,4.34,0,0,1,.57,1.06,5.27,5.27,0,0,1-.27,4.35,4.86,4.86,0,0,1-2.72,2.3C365.88,270.57,364.62,269.88,364.68,269.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.07,241.93a8.91,8.91,0,0,1,.1,1.49,15.38,15.38,0,0,1,0,1.76c0,.69-.06,1.47-.18,2.33,0,.43-.1.88-.15,1.34s-.17,1-.26,1.45c-.15,1-.45,2.06-.71,3.17a45.92,45.92,0,0,1-2.54,7,41.82,41.82,0,0,1-3.77,6.41c-.73.89-1.35,1.79-2.06,2.51l-1,1.09-1,.93a19,19,0,0,1-1.79,1.49c-.27.21-.53.4-.76.59l-.69.42a8.51,8.51,0,0,1-1.3.75c-.07-.11,1.81-1.15,4.28-3.52l1-.94,1-1.09c.7-.73,1.3-1.63,2-2.51a45.17,45.17,0,0,0,3.69-6.35,48.56,48.56,0,0,0,2.55-6.9c.27-1.09.58-2.13.75-3.12.09-.49.19-1,.28-1.43s.13-.9.19-1.33c.14-.85.19-1.62.25-2.3a17.4,17.4,0,0,0,.11-1.74A8.12,8.12,0,0,1,429.07,241.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,321.7l-4.86,13.92a17.16,17.16,0,0,0-2.52,11.55c1,6.46,1.27,16.62,13.78,18.94s69.47-2.58,69.47-2.58,34-63,33.74-62.23a56.28,56.28,0,0,0-19.12,3.83,60.38,60.38,0,0,0-10.78,6.06,75.86,75.86,0,0,1-27.7,11.56c-11.19,2.25-23.69,4.78-23.26,4.78l1.26-11.43Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43,429.16l21.88-110.93-25.76-9.39-1.77-9.21-34,12.18L349,296.91l-7.53,4.28-11.28.11s-32.84,45.41-35.74,72.48c-1.49,13.93,4.9,47,4.9,47L298.09,448l-4.35,11.63c-1.43,3.84-.58,6.5,2.81,8.8l106-.25a15.9,15.9,0,0,0,1.35-16.71Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,303.32s-5.91,13.15,0,21.45L351,317.05l2.66,14.15S379.8,326,387.5,310.32h0s-18.34,17-33.55,17.21h0l-1.72-13.63-11.8,7S339.21,309.47,339.11,303.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.52,450.73l-64.59,15.32a7.8,7.8,0,0,1-9.39-5.79l-23-96.93a7.8,7.8,0,0,1,5.8-9.39l67.56-16a7.81,7.81,0,0,1,9.4,5.79l8.08,95.1C398.78,441.44,403.52,450.73,403.52,450.73Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 320.01,
    y: 337.96,
    width: 85.05,
    height: 115.22,
    rx: 8.14,
    transform: "translate(-81.52 94.36) rotate(-13.35)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,443.69l.24-.08c.16-.06.41-.11.71-.24a8.12,8.12,0,0,0,4.94-5.45,7.86,7.86,0,0,0,.23-3c-.13-1.06-.46-2.18-.73-3.37L405,391.29l-6.64-27.83L394.71,348c-.63-2.66-1.28-5.37-1.93-8.11a17.65,17.65,0,0,0-1.2-4,7.86,7.86,0,0,0-6.81-4.24,17.56,17.56,0,0,0-4.27.74l-8.74,2.08-18,4.28-37.89,9a7.89,7.89,0,0,0-6,6.75,13,13,0,0,0,.63,4.76c.38,1.59.76,3.18,1.13,4.76L316,382.66c2.9,12.24,5.7,24,8.36,35.31L332,449.92c.29,1.25.59,2.49.88,3.71a7.93,7.93,0,0,0,8,5.95,20.55,20.55,0,0,0,3.43-.66l3.38-.8,6.53-1.54,40.32-9.48,11-2.55,2.86-.65c.64-.15,1-.21,1-.21s-.32.1-1,.26l-2.84.7-10.95,2.65-40.28,9.64-6.53,1.56-3.38.8a20.57,20.57,0,0,1-3.51.68,8.37,8.37,0,0,1-6.64-2.86,8.53,8.53,0,0,1-1.78-3.38c-.3-1.23-.59-2.47-.89-3.72-2.39-10-4.93-20.69-7.61-31.94s-5.48-23.06-8.39-35.3q-2.17-9.19-4.43-18.68c-.38-1.58-.75-3.17-1.13-4.76-.18-.8-.39-1.58-.55-2.41a8,8,0,0,1-.1-2.53,8.41,8.41,0,0,1,2.06-4.6,8.6,8.6,0,0,1,2-1.63,8.83,8.83,0,0,1,2.38-1l37.9-9,18-4.27,8.74-2.07,2.15-.51a8.45,8.45,0,0,1,2.24-.24,8.37,8.37,0,0,1,7.22,4.5,9.19,9.19,0,0,1,.75,2.05c.16.69.33,1.38.49,2.07l1.92,8.11,3.66,15.5c2.37,10,4.57,19.33,6.57,27.84,4,17,7.24,30.79,9.49,40.33.26,1.19.58,2.3.71,3.39a8.14,8.14,0,0,1-.26,3,8.26,8.26,0,0,1-2.54,4,7.92,7.92,0,0,1-2.53,1.47A7.67,7.67,0,0,1,409.29,443.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.54,
    cy: 393.88,
    r: 8.34,
    transform: "translate(-84.45 688.45) rotate(-80.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,419.35c-.19-.07,1.89,4.76,8.6,6.54s21.51,1.77,24.28,2.76,58.41,11.7,58.41,11.7,1.33-.69,1.61-6.26S323,419.35,323,419.35Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.77,367.43a1.51,1.51,0,0,0-2.22-1c-2.08,1.2-5,4.09-4.48,10a23.79,23.79,0,0,0,3,10.16l-17,1.89s-6,1.68-5.12,5.31,1.69,3.37,1.69,3.37a4,4,0,0,0-3.61,4.68c.2,2.52,3.17,4.34,3.17,4.34s-.94,4.34-.28,5.28,4.71,2.7,4.71,2.7-.81,2.8.94,4.13,10.88,3.54,10.88,3.54,19.57,1,23.73,1l19.73,4.53V404.08s-16.18-3-17.07-4c-1.89-2.17-12.36-17-12.36-17s-4.05-5-4.89-8.78A66.77,66.77,0,0,1,339.77,367.43Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,396.87a67.52,67.52,0,0,1-10.12-.1,36,36,0,0,1,5.06-.14A35.05,35.05,0,0,1,325.6,396.87Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,407a8,8,0,0,1-1.8.06c-1.11,0-2.65-.09-4.35-.23s-3.23-.32-4.33-.48a8.18,8.18,0,0,1-1.78-.35,8.48,8.48,0,0,1,1.8.08l4.33.37,4.33.34A8.78,8.78,0,0,1,327.4,407Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.31,415.31a15.5,15.5,0,0,1-3.33-.49,15.91,15.91,0,0,1-3.25-.86,14,14,0,0,1,3.32.49A15.17,15.17,0,0,1,326.31,415.31Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,318s3.05.08,8.56,8.35S445,405.62,446,413.2c1.36,9.55-3,24.25-12.83,25.47C420.13,440.3,357.83,426,357.83,426l8.12-26,41.87,2.31s-5.62-26.28-7.85-33C396.31,358.13,398.66,322.52,413.67,318Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.88,328.43a1.44,1.44,0,0,1-.17.44l-.58,1.24c-.55,1.14-1.29,2.67-2.18,4.53-1.81,3.83-4.23,9.17-6.59,15.19s-4.23,11.58-5.39,15.65c-.57,2-1,3.71-1.27,4.86-.12.53-.23,1-.32,1.33a1.61,1.61,0,0,1-.14.45,1.29,1.29,0,0,1,0-.47c.06-.37.13-.82.22-1.35.22-1.17.59-2.86,1.12-4.91a142.5,142.5,0,0,1,5.25-15.75c2.37-6,4.85-11.36,6.75-15.16,1-1.9,1.75-3.43,2.33-4.46.26-.48.49-.87.67-1.19A2.14,2.14,0,0,1,310.88,328.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,309.47a5.07,5.07,0,0,1-.48.64c-.33.39-.78,1-1.47,1.74A43.16,43.16,0,0,1,380,317.5,52.28,52.28,0,0,1,369,323.77a53.59,53.59,0,0,1-15.07,4l-.25,0,0-.25-.41-3.22c-.45-3.59-.88-7.08-1.3-10.41l.38.19-11.82,6.94-.25.15-.07-.29a47.27,47.27,0,0,1-1.17-13.55c.1-1.63.26-2.91.39-3.77.07-.43.13-.76.17-1a1.3,1.3,0,0,1,.08-.33,1.26,1.26,0,0,1,0,.34c0,.26-.07.58-.11,1-.09.86-.21,2.13-.27,3.76a48.76,48.76,0,0,0,1.34,13.44l-.32-.13,11.78-7,.34-.19,0,.38c.42,3.32.87,6.81,1.32,10.41.14,1.1.28,2.19.4,3.21l-.28-.22a55.31,55.31,0,0,0,25.85-10,47,47,0,0,0,6.34-5.5c.71-.69,1.17-1.31,1.54-1.68A6.09,6.09,0,0,1,388.2,309.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.14,348.58a3.6,3.6,0,0,1,.05-.9c.06-.58.18-1.42.36-2.44a66.68,66.68,0,0,1,1.93-7.92,64.93,64.93,0,0,1,2.88-7.62c.43-.94.8-1.7,1.07-2.22a3.11,3.11,0,0,1,.48-.77,29.52,29.52,0,0,1-1.21,3.14c-.78,1.92-1.78,4.61-2.72,7.63s-1.62,5.8-2.06,7.83A26.16,26.16,0,0,1,243.14,348.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.04,
    y: 363.54,
    width: 43.26,
    height: 73.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.3,437.25s0-.13,0-.37,0-.6,0-1.05c0-.95,0-2.31,0-4.07,0-3.56,0-8.73-.07-15.24,0-13-.07-31.41-.11-53l.24.24-43.26,0h0l.26-.26c0,28.1-.05,53.88-.06,73.71l-.2-.2,31.52.1,8.67.05,2.28,0c.51,0,.79,0,.79,0l-.75,0-2.24,0-8.63,0-31.64.11h-.2v-.2c0-19.83,0-45.61-.06-73.71v-.26H148l43.26,0h.24v.24c0,21.63-.09,40.08-.12,53.14,0,6.49,0,11.64-.06,15.18,0,1.74,0,3.09,0,4l0,1C191.31,437.14,191.3,437.25,191.3,437.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 367.14,
    width: 100.89,
    height: 80.56,
    rx: 2.8,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,264l-1-83.61c-.93-20.78,10.39-38.65,31.2-39l1.92.08a37.2,37.2,0,0,1,35.64,35.71c.71,18,1.26,37.94.74,47.57C139.21,244.7,119.13,247,119.13,247s-.12,12.14-.94,18.35L122.88,279l-30.66,7.36Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.13,247s-12.61.22-25.66-8.75c0,0,5.63,15.26,25.61,14.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,209.3c0-.17,1.91-.42,5-.69.78-.05,1.53-.17,1.68-.7a4,4,0,0,0-.42-2.34l-2.07-6.06c-2.87-8.62-4.9-15.7-4.56-15.81s3,6.78,5.82,15.41c.69,2.12,1.34,4.15,2,6.08a4.53,4.53,0,0,1,.28,3.09,2,2,0,0,1-1.34,1.09,4.63,4.63,0,0,1-1.33.13C116.81,209.54,114.88,209.48,114.88,209.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,195.25c-.34-.16-13.54-4.62-13.67,9s13.61,11,13.64,10.58S71.8,195.25,71.8,195.25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.64,209.65c-.06,0-.24.17-.64.35a2.38,2.38,0,0,1-1.78,0c-1.44-.54-2.63-2.85-2.67-5.31a7.77,7.77,0,0,1,.69-3.4,2.76,2.76,0,0,1,1.81-1.81,1.22,1.22,0,0,1,1.4.67c.18.38.09.65.16.68s.3-.23.19-.79a1.45,1.45,0,0,0-.53-.86,1.78,1.78,0,0,0-1.31-.36,3.36,3.36,0,0,0-2.51,2.09,8.15,8.15,0,0,0-.86,3.8c.07,2.75,1.45,5.34,3.42,5.93a2.54,2.54,0,0,0,2.18-.34C67.61,210,67.69,209.68,67.64,209.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,171.07c-8.57,1.32-17.35.69-24.19-4.63a40.58,40.58,0,0,1-5.48-5.18c-3-3.44-5.4-7.73-9.49-9.81-5.27-2.68-11.61-.85-17.21,1l.24-.21a25.15,25.15,0,0,0-7.81,5.5,77.75,77.75,0,0,1-6,38.8,4.16,4.16,0,0,1-2.24,2.22c-3.2,1.27-2.21-3-4.59-3.8-1.82-.63-2.7-.24-6.33-.35-1.26-3.43-2-12.78-3.06-17.83-3-3.17-5.76-9-5.87-13.63s2.44-10.43,2.44-10.43c3.46-6.57,5.47-9.93,10.78-11.75l.12.05c4.77-1.86,10.62-1.82,14.48,1.52,1-7.11,7.36-12.68,14.33-14.42s18.11-.53,24.75,2.23c4.53,1.88,8.91,5.46,14,10.62h0c.67.68,1.36,1.39,2.06,2.13l.17.19a12.07,12.07,0,0,0,5.17,1.6c3,.34,4.92-.61,7-2.86.63-.69,1.42-1.55,2.3-1.27a1.91,1.91,0,0,1,1.06,1.32c1,3-.33,6.32-2.57,8.5a14,14,0,0,1-3.7,2.53,9.62,9.62,0,0,0,5.5,3.07,6.93,6.93,0,0,1,4.62,2.95,4.79,4.79,0,0,1,.88,2.67C159.05,167.59,153.31,170.21,147.73,171.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,165.09l-.16.14-.51.35a6.36,6.36,0,0,1-.85.54,10.57,10.57,0,0,1-1.22.62,17.79,17.79,0,0,1-8.58,1.45,22.65,22.65,0,0,1-12-4.6,39.1,39.1,0,0,1-10.23-12.06c-1.42-2.44-2.58-4.93-3.86-7.24a26.43,26.43,0,0,0-4.4-6.13,13.56,13.56,0,0,0-5.72-3.56,9.71,9.71,0,0,0-3-.39,10.86,10.86,0,0,0-2.79.5,11.64,11.64,0,0,0-6.48,5.37,13.78,13.78,0,0,0-1.07,3s0-.07,0-.21.06-.36.1-.61a10.57,10.57,0,0,1,.79-2.25,11.3,11.3,0,0,1,2.27-3,11.78,11.78,0,0,1,4.27-2.58,11,11,0,0,1,2.88-.55,10.47,10.47,0,0,1,3.15.37,14,14,0,0,1,5.92,3.63,27.13,27.13,0,0,1,4.49,6.22c1.3,2.32,2.45,4.81,3.87,7.23a39.17,39.17,0,0,0,10.08,11.95,22.57,22.57,0,0,0,11.78,4.61,18,18,0,0,0,8.47-1.28C150.45,165.76,151.35,165,151.39,165.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,156.33a3.52,3.52,0,0,1-.73.49,14,14,0,0,1-2.13,1.05,20,20,0,0,1-3.37,1.07,23.65,23.65,0,0,1-4.31.52,24.34,24.34,0,0,1-4.32-.34,20.81,20.81,0,0,1-3.42-.93,15.62,15.62,0,0,1-2.17-1c-.5-.27-.76-.43-.74-.46s1.13.5,3,1.11a23.73,23.73,0,0,0,3.38.81,24.6,24.6,0,0,0,4.24.3,25.93,25.93,0,0,0,4.23-.47,25,25,0,0,0,3.34-1C152.19,156.88,153.26,156.25,153.31,156.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,166.72a3.79,3.79,0,0,1,.18,1.29,23.61,23.61,0,0,1-.07,3.57,12.38,12.38,0,0,1-.41,2.52,1.44,1.44,0,0,1-1.37,1,2.56,2.56,0,0,1-1.52-.75l-4.88-4.52.72-.42c.22,1,.46,1.93.7,2.93.65,2.76,1.26,5.38,1.82,7.77l.3,1.31-1-.92A32.08,32.08,0,0,1,66,173.83a11.17,11.17,0,0,1-1.47-3c.2-.14,2.31,4.38,7.43,9.06l-.66.39c-.58-2.39-1.22-5-1.89-7.75-.24-1-.47-2-.7-2.94l-.33-1.42,1,1,4.8,4.58a2,2,0,0,0,1,.6.74.74,0,0,0,.71-.54,13,13,0,0,0,.47-2.33C76.85,168.55,76.77,166.73,76.9,166.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.27,217.15c-.23,0-10.45-4-10.45-4s-3,5.91.62,8.62,7.94,1,8.63-.61A26.83,26.83,0,0,0,114.27,217.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,222.3a13.09,13.09,0,0,1-1.44.45,10.21,10.21,0,0,1-4-.24h0A4.92,4.92,0,0,1,103.2,216a11,11,0,0,1,1-2.63l-.52.19c3.1,1.16,5.83,2.15,7.79,2.82a14.34,14.34,0,0,0,3.2.93,14.59,14.59,0,0,0-3-1.44c-1.91-.81-4.6-1.9-7.69-3.11l-.34-.13-.18.32a11.77,11.77,0,0,0-1.09,2.85,6.36,6.36,0,0,0,.52,4.93,6.26,6.26,0,0,0,3.47,2.45h0a9.37,9.37,0,0,0,4.25-.05C111.63,222.84,112,222.32,112,222.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.83,195.7a2.9,2.9,0,0,1-2.9,2.82,2.77,2.77,0,0,1-2.85-2.75,2.9,2.9,0,0,1,2.89-2.83A2.77,2.77,0,0,1,131.83,195.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61,185.8c-.37.36-2.48-1.36-5.58-1.48s-5.43,1.35-5.75,1c-.16-.17.23-.85,1.25-1.53a7.81,7.81,0,0,1,4.62-1.24,7.53,7.53,0,0,1,4.43,1.66C133.5,184.94,133.79,185.64,133.61,185.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33,194.4a2.89,2.89,0,0,1-2.89,2.82,2.77,2.77,0,0,1-2.86-2.75,2.9,2.9,0,0,1,2.89-2.83A2.78,2.78,0,0,1,103.33,194.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,185.26c-.38.36-2.49-1.36-5.59-1.48s-5.42,1.35-5.74.95c-.16-.18.23-.85,1.25-1.54A7.84,7.84,0,0,1,97.78,182a7.53,7.53,0,0,1,4.42,1.65C103.12,184.39,103.42,185.09,103.24,185.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,175.49c-.46.78-3.42-.18-7.08-.42s-6.72.22-7.06-.62c-.15-.4.5-1.1,1.81-1.69a11.6,11.6,0,0,1,5.48-.87,11.8,11.8,0,0,1,5.3,1.66C104.3,174.33,104.84,175.12,104.64,175.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,176.59c-.66.69-3.17-.12-6.2-.23s-5.61.33-6.18-.43c-.25-.37.17-1.08,1.31-1.72a9.69,9.69,0,0,1,5.07-1,9.52,9.52,0,0,1,4.91,1.56C134.09,175.5,134.42,176.25,134.13,176.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,317.1c6.86,6.55,60.91,32.94,87.8,31.31s60.7-74.14,60.7-74.14L205.91,259.6,199.39,269,161.91,306S122,276.71,113.43,271.41s-22.81-21.59-43.18-4.07S69.07,303.73,83.08,317.1Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,255.1s-5.82-4.64-6.22-7.4.2-5.52-.69-7.2,3.16-2.56,5.23,0,3.75,4.44,3.75,4.44,2.17-13.61,3.15-17.55,2.57-13.71,3-17,1.38-7.89,3.25-7.89h.5s2.17.2,1.77,2.07c0,0,.89-9.17,5.33-8.87,0,0,2.76,0,2.36,4.44s-1.18,10.15-1.18,10.15l3-10.75s.29-3.35,3.25-2.86,2.57,3.16,2,7.69-2.46,15.09-2.46,15.09,3.94-13.7,5.52-14.69,4.34-1.09,3.45,3.94-3.15,15.88-3.15,15.88-.6,17.35-1.38,21.1-12,27.19-12,27.19L209.1,261.53s3.61-4.07,3.31-4.36S210.64,255.1,210.64,255.1Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.53,244.85a21.81,21.81,0,0,1-.25,3,19.22,19.22,0,0,1-.21,3,6,6,0,0,1-.31-3.05A5.85,5.85,0,0,1,212.53,244.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,223.23a13.75,13.75,0,0,1,.07-2.95c.13-1.82.4-4.33.87-7.07s1-5.2,1.51-7a15.76,15.76,0,0,1,.91-2.81,20.07,20.07,0,0,1-.55,2.9c-.38,1.77-.89,4.23-1.36,7s-.79,5.21-1,7A19.88,19.88,0,0,1,221.3,223.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.58,223.23a9.19,9.19,0,0,1,0-2.37,52.86,52.86,0,0,1,.73-5.65,56.43,56.43,0,0,1,1.29-5.56,9.09,9.09,0,0,1,.8-2.22,13.07,13.07,0,0,1-.44,2.32c-.32,1.41-.74,3.37-1.14,5.55s-.68,4.16-.88,5.6A13.46,13.46,0,0,1,228.58,223.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,225.54a18.49,18.49,0,0,1,1.81-8.23,30.86,30.86,0,0,1-.87,4.12A33.42,33.42,0,0,1,235.64,225.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36,320.54a1.19,1.19,0,0,1-.11-.31l-.25-.94c-.21-.85-.51-2.06-.88-3.6a36.63,36.63,0,0,0-1.72-5.59,16.2,16.2,0,0,0-1.76-3.17,13,13,0,0,0-2.88-2.84c-4.55-3.52-10.11-7.55-16.35-11.93s-13.14-9.12-20.27-14.28c-3.56-2.58-7-5.08-10.47-7.42s-6.82-4.45-10-6.49a29.69,29.69,0,0,0-4.9-2.54,8.37,8.37,0,0,0-2.53-.58l-1.29-.14-1.27,0a32.53,32.53,0,0,0-9.27,1.14A47.8,47.8,0,0,0,70,267.23c-1.38.83-2.42,1.53-3.12,2l-.8.54a1.36,1.36,0,0,1-.29.17,1.58,1.58,0,0,1,.25-.21l.78-.58c.68-.51,1.7-1.23,3.07-2.09a46.3,46.3,0,0,1,12.44-5.62,32.33,32.33,0,0,1,9.37-1.21l1.29,0,1.31.13a9.18,9.18,0,0,1,2.64.6,29.81,29.81,0,0,1,5,2.56c3.23,2,6.62,4.14,10.06,6.48s6.93,4.84,10.5,7.42c7.12,5.15,14,9.9,20.24,14.31s11.76,8.46,16.3,12a13.33,13.33,0,0,1,2.92,2.94,16.49,16.49,0,0,1,1.76,3.25,35.85,35.85,0,0,1,1.65,5.65c.33,1.55.59,2.77.78,3.63.08.39.15.7.2.94A1.42,1.42,0,0,1,166.36,320.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.9 468.36 52.56 453.03 160.14 454.97 165.12 468.36 48.9 468.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.53,251.19c-2.6.87-30.25,27.06-29.09,57.62S54.29,433.05,54.29,433.05s-12.68,5.19-8.94,17,116,8,116,8,1.07,1,1.55-8.07c.67-12.49-18.62-134-18.62-134s-16.82-33.88-24-49.79l-1.09-8.9L70.72,240.83Z",
    style: {
      fill: "#9DE6B2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,320.54s37.46,31.67,61.79,33.76l-1.81-11.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,314.25a3.83,3.83,0,0,1,.71.43l2,1.3c.84.58,1.88,1.28,3.12,2s2.6,1.7,4.18,2.63,3.27,2,5.15,3,3.9,2.15,6,3.29c4.3,2.23,9.08,4.55,14.21,6.76s10.1,4.09,14.66,5.7,8.73,2.9,12.25,3.9c1.75.53,3.35.94,4.75,1.33s2.62.7,3.61.94l2.28.6a4.4,4.4,0,0,1,.79.24,4.5,4.5,0,0,1-.81-.14l-2.31-.5c-1-.21-2.22-.5-3.63-.86s-3-.75-4.78-1.26c-3.54-.95-7.71-2.24-12.31-3.79s-9.57-3.47-14.71-5.68-9.93-4.56-14.22-6.81c-2.13-1.16-4.16-2.24-6-3.35S90.3,322,88.75,321s-2.93-1.89-4.14-2.69-2.25-1.52-3.07-2.13l-1.91-1.39A6.26,6.26,0,0,1,79,314.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78,257.34a4.38,4.38,0,0,1,.15.82c.1.59.23,1.37.39,2.35a80.47,80.47,0,0,0,1.94,8.52l.11.4-.38-.16c-5.44-2.39-12.73-5.42-20.83-8.34C91.22,257.69,83,255.18,77,253.5l-7.12-1.95L67.93,251a3.19,3.19,0,0,1-.67-.22,3,3,0,0,1,.69.12l2,.43c1.7.39,4.15,1,7.17,1.78,6,1.6,14.3,4.05,23.25,7.3,8.13,2.93,15.4,6,20.82,8.47l-.27.23a70.45,70.45,0,0,1-1.78-8.59c-.14-1-.23-1.83-.28-2.38A4,4,0,0,1,118.78,257.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.84,432.37a21.48,21.48,0,0,1-4.6.89,21.6,21.6,0,0,1-4.67.38,20.11,20.11,0,0,1,4.6-.89A21.6,21.6,0,0,1,62.84,432.37Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcImage);
export default __webpack_public_path__ + "static/media/FC-image.71208f15c314a769e3d43a51f5da5a92.svg";
export { ForwardRef as ReactComponent };